import { ViatorProductListResponse } from "@/types/viator";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import api from "@/config/axiosConfig";

const ITEMS_PER_PAGE = 20;

// Viator product list fetching function
const fetchViatorProducts = async ({
  locationId,
  fromCurrency,
  toCurrency,
  currentPage,
}: {
  locationId: number;
  fromCurrency: string;
  toCurrency: string;
  currentPage: number;
}): Promise<ViatorProductListResponse> => {
  try {
    const response = await api.experiences.get<ViatorProductListResponse>(
      "/viator-products",
      {
        params: {
          location_id: locationId,
          limit: ITEMS_PER_PAGE,
          offset: currentPage * ITEMS_PER_PAGE,
          from_currency: fromCurrency,
          to_currency: toCurrency,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching Viator products:", error);
    throw new Error("Failed to fetch Viator products");
  }
};

// Hook for fetching Viator products with pagination
export const useViatorProducts = (
  locationId: number,
  fromCurrency: string,
  toCurrency: string,
  currentPage: number
) => {
  return useQuery({
    queryKey: [
      "viatorProducts",
      locationId,
      fromCurrency,
      toCurrency,
      currentPage,
    ],
    queryFn: () =>
      fetchViatorProducts({
        locationId,
        fromCurrency,
        toCurrency,
        currentPage,
      }),
    staleTime: Infinity,
    retry: false,
  });
};
